import { render } from "./index.vue?vue&type=template&id=9a3a5ca4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9a3a5ca4&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a3a5ca4"]])

export default __exports__